import { GroupColumn } from "./types"

export function canExpandGroup<T>(group: GroupColumn<T>): boolean {
  return group.minVisibleColumns < group.columns.length
}
